import React, { useEffect, useState, useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { getThisMonthVehicleTypeDashboardApi } from "../../../services/DashboardService";
import { toast } from "react-toastify";

const VehicleTypeChart = ({ selectedServicecenter }) => {
  const [vehicleData, setVehicleData] = useState([]);
  const getVehicle = () => {
    getThisMonthVehicleTypeDashboardApi(
      selectedServicecenter == "all" ? "" : selectedServicecenter
    )
      .then((res) => {
        setVehicleData(
          Object.values(res?.data?.results?.vehicle_type_breakdown)
        );
        console.log(Object.values(res?.data?.results?.vehicle_type_breakdown));
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    if (selectedServicecenter) {
      getVehicle();
    }
  }, [selectedServicecenter]);
  const series = useMemo(
    () => vehicleData?.map((v) => Number(v.value)),
    [vehicleData]
  );
  const labels = useMemo(() => vehicleData?.map((v) => v.label), [vehicleData]);

  const options = {
    chart: {
      type: "pie",
      width: "100%",
    },
    labels: labels,
    colors: ["#7f0000", "#b71c1c", "#c62828", "#d32f2f", "#e53935", "#f44336"],
    dataLabels: {
      formatter: function (_, opts) {
        return opts.w.config.series[opts.seriesIndex];
      },
      style: {
        fontSize: "13px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
    },
    legend: {
      position: "bottom",
      labels: {
        colors: "#333",
      },
    },
    responsive: [
      {
        breakpoint: 576,
        options: {
          chart: {
            height: 220,
          },
          dataLabels: {
            style: { fontSize: "11px" },
          },
          legend: {
            fontSize: "12px",
          },
        },
      },
    ],
  };

  return (
    <div className="card p-2 border-0 shadow-sm rounded-3 h-100">
      <div className="mb-2 px-1">
        <h5>Vehicle Type</h5>
      </div>
      <div className="px-2">
        {series?.length > 0 ? (
          <ReactApexChart
            key={JSON.stringify(series) + JSON.stringify(labels)}
            options={options}
            series={series}
            type="pie"
            height={300}
          />
        ) : (
          <div className="text-center">
            <span className="my-3">No data found</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default VehicleTypeChart;
